const LINK_PREVIEW_CHARACTER_LIMIT = 50;
const MESSAGE_AI_NAME = "AI Assistant";
const SM_BREAKPOINT_PX = 400;
const MAX_LINKS_TO_RENDER = 3;
const MIN_LINKS_TO_RENDER = 1;

const constants = {
  LINK_PREVIEW_CHARACTER_LIMIT,
  MESSAGE_AI_NAME,
  SM_BREAKPOINT_PX,
  MAX_LINKS_TO_RENDER,
  MIN_LINKS_TO_RENDER,
};

export default constants;
